var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconcontinue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon=continue"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 2.11111L1 17.8889C1 18.5035 1.49653 19 2.11111 19C2.72569 19 3.22222 18.5035 3.22222 17.8889L3.22222 2.11111C3.22222 1.49653 2.7257 1 2.11111 1C1.49653 1 1 1.49653 1 2.11111Z",
    fill: "#653024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9894 3.32552C11.4234 2.89149 12.1283 2.89149 12.5623 3.32552L18.8957 9.65885C19.3297 10.0929 19.3297 10.7977 18.8957 11.2318L12.5623 17.5651C12.1283 17.9991 11.4234 17.9991 10.9894 17.5651C10.5554 17.1311 10.5554 16.4262 10.9894 15.9922L15.4269 11.5547H6.11095C5.49636 11.5547 4.99984 11.0582 4.99984 10.4436C4.99984 9.82899 5.49636 9.33246 6.11095 9.33246L15.4269 9.33247L10.9894 4.89844C10.5554 4.46441 10.5554 3.75955 10.9894 3.32552Z",
    fill: "#653024"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconcontinue);
export default __webpack_public_path__ + "static/media/icon=continue.4aac61ac3c70dcd90f764c8e913d7a5f.svg";
export { ForwardRef as ReactComponent };